module.exports = __webpack_public_path__ + "static/img/recommend02.7ef60356.png";